export default function Loading() {
    return (
        <div className="center-wrapper">
            <h1>Loading...</h1>
        </div>
    );
}
